module.exports = __webpack_public_path__ + "static/media/gusset-box-exterior.e20b9001.png";